module.exports = __webpack_public_path__ + "staticcomp/img/cover.e6e55a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/17/cover.jpg
// module id = rfpw
// module chunks = 39